import React from 'react';
import { Container, Fade } from 'reactstrap';
import { PractitionerFormCard } from '../../../containers/Cards';
import OrganizationProvider from '../../../containers/Providers/Organizations';
import PractitionerProvider from '../../../containers/Providers/Practitioner';
import { RouteComponentProps, withRouter } from 'react-router';

const PractitionerEdit = ({
  match,
  history,
}: RouteComponentProps<{ organizationId: string; practitionerId: string }>) => {
  return (
    <OrganizationProvider organizationId={match.params.organizationId}>
      <PractitionerProvider practitionerId={match.params.practitionerId}>
        <Fade>
          <Container fluid className="mt-3">
            <PractitionerFormCard
              onComplete={(practitionerId: string) => {
                history.push(
                  `/Organization/${match.params.organizationId}/practitioner/${practitionerId}`,
                );
              }}
            />
          </Container>
        </Fade>
      </PractitionerProvider>
    </OrganizationProvider>
  );
};
export default withRouter(PractitionerEdit);
